export default "__VITE_ASSET__VxZMPaEV__"